export const getShortenedText = (text: string) => {
  const tempTextData = text
    .replace(/\n/g, ' ') // 줄바꿈 제거
    .slice(0, 100);
  return text.length > 100 ? `${tempTextData} ...` : tempTextData;
};

/**
 * 긴 HTML 문자열을 chunkSize 만큼 자르되 마지막이 태그 중간이면 그 뒤 첫번째 닫는 태그(</...>)의 >까지 확장하여 끊는다.
 */
export function splitHtmlByTagBoundary(html: string, chunkSize: number): string[] {
  const result: string[] = [];

  let pos = 0;
  while (pos < html.length) {
    let end = pos + chunkSize;

    if (end >= html.length) {
      result.push(html.slice(pos));
      break;
    }

    const closeTagStartIdx = html.indexOf('</', end);
    let closeTagEndIdx = -1;
    if (closeTagStartIdx !== -1) {
      closeTagEndIdx = html.indexOf('>', closeTagStartIdx);
    }

    if (closeTagEndIdx !== -1) {
      end = closeTagEndIdx + 1;
    }

    result.push(html.slice(pos, end));
    pos = end;
  }

  return result;
}
